<template>
  <el-select
    v-loading="requestLoading"
    :value="value"
    @input="inputtt"
    :multiple="multiple"
    filterable
    clearable
    placeholder="请选择客户分组"
    @change="changeHanlder"
    :style="{
      width: width,
    }"
  >
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "Fmerpv2WebCustomerGroupSelect",
  props: {
    value: [Array, String],
    multiple: {
      type: Boolean,
      default: true,
    },
    width: {
      type: [Number, String],
      default: "180px",
    },
  },
  data() {
    return {
      requestLoading: true,
      list: [],
    };
  },

  mounted() {
    this.flushList();
  },

  methods: {
    inputtt(e) {
      this.$emit("input", e || null);
    },
    changeHanlder(val) {
      this.$emit("change", val);
      this.$emit(
        "selectCustomerGroup",
        this.list.find((e) => e.id == val)
      );
    },
    async flushList() {
      this.requestLoading = true;
      let requestRes = await this.$api.customerGroup_findAllList({showFailMessage: false});
      if (requestRes && requestRes.success) {
        this.list = requestRes.data;
      }
      setTimeout(() => {
        this.requestLoading = false;
      }, 200);
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/CustomerGroupSelect.vue